import FacebookOnboardingPage from './FacebookOnboardingPage';

export default FacebookOnboardingPage;
